import React from 'react';

import BreadcrumbsLink from './Link';
import BreadcrumbsText from './Text';
import BreadcrumbsSeparator from './Separator';

import { IconType, ITextProps } from '../../types/teams.types';

const Item = ({
  name,
  iconType,
  refSrc,
  ...restProps
}: ITextProps & React.HTMLProps<HTMLLIElement>): JSX.Element => {
  const ItemElement =
    iconType !== IconType.Home ? BreadcrumbsText : BreadcrumbsLink;

  const itemProps: ITextProps = {
    name,
    iconType,
    refSrc,
  };

  return (
    <li {...restProps}>
      {iconType !== IconType.Home && <BreadcrumbsSeparator />}
      <ItemElement {...itemProps} />
    </li>
  );
};

export default Item;
